module.exports = __webpack_public_path__ + "static/img/function21.889fc68.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/function21.gif
// module id = kEWy
// module chunks = 0